export function escapeSpecialChars (text: string) {
    return text.replace(/[_[\]{}()*+?.,\\^$|#]/g, '\\$&');
}
